import { TestImage } from "@assets/constant/index.constant";
import { Button } from "@components/ui/button";
import { GeneralCard, TableCard } from "@ui/internal/components/card";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { endpoint } from "@services/api.services";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { CategoryData, DurationData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { NavLink, useParams, useSearchParams } from "react-router";
import { ColumnList, DiscountColumnList } from "./column/index.column";
import PaymentModeForm, { PaymentDiscountForm } from "./form/index.form";

type Params = {
  setup: "mode" | "discounts";
};
const index = () => {
  const pathname = usePathname();
  const { setup } = useParams<Params>();
  const [searchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const endpointValue =
    setup === "mode"
      ? endpoint["paymentmode"]
      : setup === "discounts"
      ? endpoint["discount"]
      : "";
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch } = useListData<
    QueryData<CategoryData | DurationData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpointValue,
    key: `${pathname}-listing`,
    window: true,
  });

  const columns =
    setup === "mode"
      ? ColumnList()
      : setup === "discounts"
      ? DiscountColumnList()
      : [];
  return (
    <>
      <TableCard
        bulkActions
        inject_ui_table_actions={
          <>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="defaultoutline">Manage Setup</Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-fit" align="start">
                <DropdownMenuRadioGroup>
                  <NavLink to={"/payment/mode"}>
                    <DropdownMenuItem>Manage Pay Mode</DropdownMenuItem>
                  </NavLink>
                  <NavLink to={"/payment/discounts"}>
                    <DropdownMenuItem>Manage Discounts</DropdownMenuItem>
                  </NavLink>
                </DropdownMenuRadioGroup>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        }
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={
          setup === "mode" ? (
            <PaymentModeForm />
          ) : setup === "discounts" ? (
            <PaymentDiscountForm />
          ) : (
            <> </>
          )
        }
        formId={pathname}
        // showOrientation
        orientationPosition={false}
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            content={{
              images: [TestImage, TestImage, TestImage],
              title: "Aayush Maharjan",
              subtitle: "Frontend Developer",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        refetch={refetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        endpoint={endpointValue}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
